import { Box, Typography } from "@mui/material";
import { Bar, BarChart, Rectangle, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Primary } from "../../constants/Spalvos";

/**
 * Vertikalus vienmatis stulpelinis grafikas su labeliais
 * @isLoading {boolean} pozymis, kuris parodo ar reikia rodyti, kad duomenys kraunami
 * @pavadinimas {string} tekstas, kuri reikia rodyti virs grafiko
 * @duomenys {[]} duomenu masyvas, formatas [{label: "pavadinimas", value: 7}, {label: "pavadinimas2", value: 2}, ...]
 * @margin kaire grafiko antraste, nuo label pavadinimu priklauso kiek pastumti i desine reikia grafika
 * @returns
 */
const SveikatStulpGrafikas = ({ isLoading, pavadinimas, duomenys, margin }) => {
  const data = duomenys.filter((d) => !isNaN(d.value));
  return (
    <>
      <Typography>{pavadinimas}</Typography>
      {isLoading ? (
        <Box
          width="100%"
          height="100%"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography>Duomenys kraunami...</Typography>
        </Box>
      ) : (
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} layout="vertical" margin={{ left: margin, right: 30 }}>
            <XAxis type="number" />
            <YAxis dataKey="label" type="category" />
            <Tooltip />
            <Bar
              dataKey="value"
              barSize={20}
              label={{ position: "right", fill: "black" }}
              fill={Primary}
              activeBar={<Rectangle fill={Primary} stroke="black" />}
            />
          </BarChart>
        </ResponsiveContainer>
      )}
    </>
  );
};

export default SveikatStulpGrafikas;
